import React from 'react'
import './TxPlanPhaseAddProcedureRow.css'

interface TxPlanPhaseAddProcedureRowProps {
  onAddProcedure: () => void
}

const TxPlanPhaseAddProcedureRow = ({
  onAddProcedure,
}: TxPlanPhaseAddProcedureRowProps): React.ReactElement => {
  return (
    <button
      type="button"
      className="tx-plan-phase-add-procedure-row"
      onClick={onAddProcedure}
      aria-label="Add procedures to this phase"
    >
      <i className="ti ti-plus tx-plan-phase-add-procedure-icon" aria-hidden />
      <span>Add procedures</span>
    </button>
  )
}

export default TxPlanPhaseAddProcedureRow
